import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import useWaveform from "./hooks/useWaveform";
import useFillWaveform from "./hooks/useFillWaveform";

function ConnectedWaveform({ id, index, src, baseStart, baseEnd, duration, onNext, active, selected, currentAutomix}) {
  const { dimension, context, cursorPosition } = useWaveform(index, src, active);
  
  const fullWidth = (dimension) ? dimension.width : 0;
  const { seek } = useFillWaveform(context, selected, id, fullWidth, duration, baseStart, baseEnd, onNext, cursorPosition, currentAutomix);

  const dpi = window.devicePixelRatio;
  return (dimension && src) ? (
    <>
      <canvas id={`wc${index}`} width={dimension.width * dpi} height={dimension.height * dpi} style={{width: dimension.width, height: dimension.height}} />
      { active && (
        <div id={`icf-seek`} className={`cf-seek`} onClick={seek} style={{bottom: dimension.height / 4, height: dimension.height / 1}}>
          <svg id="jump_cf_hover" width="4" height={dimension.height / 1} style={{ display: (cursorPosition !== null && parseInt(currentAutomix.currentid) === parseInt(id)) ? `block` : `none`, position: `relative`, left: 0, transform: `translate3d(${cursorPosition}px, 0px, 0px)`}}>
            <path stroke="#FFF8" strokeWidth="1" d={`M1,0 v${dimension.height / 1}`}></path>
          </svg>
        </div>
      ) }
    </>
  ) : null;
}

ConnectedWaveform.propTypes = {
  id: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  src: PropTypes.string.isRequired,
  duration: PropTypes.any.isRequired,
  baseStart: PropTypes.number.isRequired, 
  baseEnd: PropTypes.number.isRequired, 
  onNext: PropTypes.func,
  active: PropTypes.bool.isRequired,
  selected: PropTypes.bool.isRequired
}

const Waveform = connect(
  state => ({
    currentAutomix: state.currentAutomix,
  })
)(ConnectedWaveform);

export default Waveform;
